import React from 'react';
import PropTypes from 'prop-types';
import { AccountSelectorWithHeaderPropTypes } from './shapes';

export const WithOldUIHeader = (AccountSelector) => {
  const subComponent = class extends React.Component {
    constructor(props) {
      super(props);
      this.state = { showAccountSelectorView: false };
    }

    showAccountSelectorView = () => {
      this.setState({ showAccountSelectorView: true });
    }

    hideAccountSelectorView = () => {
      this.setState({ showAccountSelectorView: false });
    }

    render = () => (
      <React.Fragment>
        <li className="navbar-vertical-divider" />
        {/* eslint-disable jsx-a11y/click-events-have-key-events */}
        {/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */}
        <li
          className="dropdown customer-account-selector"
          onClick={this.showAccountSelectorView}
        >
          {/* eslint-disable jsx-a11y/anchor-is-valid */}
          {/* eslint-disable jsx-a11y/interactive-supports-focus */}
          <a
            aria-haspopup="true"
            className="dropdown-toggle"
            aria-expanded="false"
            role="button"
            onMouseEnter={this.hideAccountSelectorView}
          >
            <span className="navbar-customer-account-container">
              <span className="navbar-user displayname-span type-bold">{this.props.title}</span>
              <span className="navbar-user displayname-span">{this.props.subTitle}</span>
            </span>
            <span className="caret" />
          </a>
          <ul className="dropdown-menu customer-account-selector">
            <AccountSelector
              {...this.props}
              showAccountSelectorView={this.state.showAccountSelectorView}
            />
          </ul>
        </li>
        <li className="navbar-vertical-divider" />
      </React.Fragment>
    );
  };
  subComponent.propTypes = {
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
  };
  return subComponent;
};

WithOldUIHeader.propTypes = AccountSelectorWithHeaderPropTypes;
